import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ThinFooter from "../Footer/ThinFooter";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import SubscriptionChannelCard from "../Atomics/SubscriptionChannelCard/SubscriptionChannelCard";
import Paginate from "../Atomics/Paginate/Paginate";
import { useContext, useEffect, useState } from "react";
import { ProfileContext } from "../../context/profile";
import { subscribersFetcher } from "../../api/requests";
import { paginate } from "../../api/requests";
import { Spinner } from "react-bootstrap";

const Subscriptions = () => {
  const { profile } = useContext(ProfileContext);
  const [channels, setChannels] = useState();
  const [subscribed, setSubscribed] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const handlePageChange = async (arg) => {
    setIsLoading(true);

    try {
      let res;

      if (typeof arg === "string") {
        const startIndex = arg.indexOf("api") + 3;
        res = await paginate.get(arg.slice(startIndex));
      } else if (typeof arg === "object" && arg.baseUrl && arg.page) {
        res = await paginate.getByNumber(arg.baseUrl, arg.page);
      } else {
        res = arg;
      }

      setChannels(res);
      setPaginationInfo(res);
      setTotalCount(res.count);
    } catch (error) {
      console.error("Error fetching page:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (profile && profile.user) {
      const id = profile.user;
      const getChannel = async () => {
        setIsLoading(true);
        try {
          const fetchedChannels =
            await subscribersFetcher.getUsersFollowedChannels(id);
          setChannels(fetchedChannels);
          setPaginationInfo(fetchedChannels);
          setTotalCount(fetchedChannels.count);
        } catch (error) {
          console.error("Error fetching channels:", error);
        } finally {
          setIsLoading(false);
        }
      };
      getChannel();
    }
  }, [profile, refresh]);

  return (
    <ContentWrapper>
      <Container
        fluid
        style={{
          display: "flex",
          justifyContent: "center",
          minHeight: "calc(100vh - 135px)",
          height: "100%",
        }}
      >
        <div
          className="video-block section-padding"
          style={{
            paddingLeft: "30px",
            paddingRight: "30px",
            minHeight: "calc(100vh - 167px)",
          }}
        >
          <Row>
            <Col md={12}>
              <SectionHeader heading="کانال های دنبال شده" />
            </Col>
            {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ width: "100%", height: "200px" }}
              >
                <Spinner animation="border" role="status" />
              </div>
            ) : channels?.results?.length > 0 ? (
              channels?.results?.map((item, index) => (
                <Col xl={3} sm={6} className="mb-3" key={index}>
                  <SubscriptionChannelCard
                    imgSrc={
                      item.channel?.avatar
                    }
                    channelName={item.channel?.name}
                    subscriberCount={item.channel?.subscribe_count} 
                    channelId={item?.channel?.id}
                    subscriptionId={item?.id}
                    initialSubscribed={subscribed}
                    setRefresh={setRefresh}
                    refresh={refresh}
                  />
                </Col>
              ))
            ) : (
              <div className="mr-3">کانالی وجود ندارد.</div>
            )}
          </Row>
          <Paginate
            count={totalCount}
            value={paginationInfo}
            onPageChange={handlePageChange}
            limit={12}
          />
        </div>
      </Container>
      <ThinFooter />
    </ContentWrapper>
  );
};

export default Subscriptions;
